import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, Fade, makeStyles } from '@material-ui/core';
import Tooltip from '../tooltip';
import { ReactComponent as CoursesLinkIcon } from '../../../assets/icons/school-dark.svg';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    width: 16,
    height: 16,
  },
  iconWithCourses: {
    marginRight: spacing(1.5),
  },
  courses: {
    marginBottom: spacing(-0.5),
  },
}));

const CoursesIconTooltip = ({
  className = undefined,
  text,
  numberOfCourses = 0,
  isVisible = false,
}) => {
  const classes = useStyles();
  const hasCourses = numberOfCourses !== 0;

  return (
    <Fade
      className={classNames(classes.root, className)}
      in={isVisible}
      unmountOnExit
    >
      <div className={classes.root}>
        <Tooltip
          customIconClass={classNames(classes.icon, {
            [classes.iconWithCourses]: hasCourses,
          })}
          text={text}
          icon={CoursesLinkIcon}
        />
        {hasCourses && (
          <Typography variant="subtitle2" className={classes.courses}>
            {numberOfCourses}
          </Typography>
        )}
      </div>
    </Fade>
  );
};

CoursesIconTooltip.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  numberOfCourses: PropTypes.number,
  isVisible: PropTypes.bool,
};

export default CoursesIconTooltip;
